import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salveazaTargetareMapare } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useSalveazaTargetareMapare() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: salveazaTargetareMapare,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.mapare() });
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.stats() });
    },
  });
}
